/**
 * Production portal exits to the Club 4X4 marketing site and auth deep-links.
 * @module utils/portalMarketingRedirect
 */

import { CLUB4X4_SELF_SERVICE_HREF } from '../claims/contactLinks'
import { MARKETING_LOGIN_QUERY } from './marketingAuthEntry'

/** Auth0 logout returnTo (Club 4X4 self-service hub). */
export const PORTAL_LOGOUT_RETURN_URL = CLUB4X4_SELF_SERVICE_HREF

/** Portal sign-in URL that skips the gateway and opens Auth0 login after logout. */
export function portalMarketingLoginReturnUrl(origin = window.location.origin): string {
  const base = origin.replace(/\/$/, '')
  return `${base}/signin?${MARKETING_LOGIN_QUERY}=1`
}

/** Full navigation to the Club 4X4 self-service page (replaces history entry). */
export function redirectToClub4x4Website(): void {
  window.location.replace(CLUB4X4_SELF_SERVICE_HREF)
}
